import { CRVPaymentStateTypes, CRVPaymentActionTypes } from "./CRVPayment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CRVPaymentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CRVPaymentReducer = (
  state: CRVPaymentStateTypes = INITIAL_STATE,
  action: any
): CRVPaymentStateTypes => {
  switch (action.type) {
    case CRVPaymentActionTypes.FETCH_ALL_CRV_PAYMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CRVPaymentActionTypes.FETCH_ALL_CRV_PAYMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CRVPaymentActionTypes.FETCH_ALL_CRV_PAYMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CRVPaymentActionTypes.FETCH_ALL_CRV_PAYMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CRVPaymentActionTypes.FETCH_ONE_CRV_PAYMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CRVPaymentActionTypes.FETCH_ONE_CRV_PAYMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CRVPaymentActionTypes.FETCH_ONE_CRV_PAYMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CRVPaymentActionTypes.FETCH_ONE_CRV_PAYMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CRVPaymentReducer;
